import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import type { EditorPointer } from '@wix/editorx-core-api';
import { EditorPointerAPI } from '@wix/editorx-core-api';

import { PlatformApiMethods } from '../../../types/platformApi';
import { initBuilderServices } from '../builderServices/init';

import { getCustomEditActions } from './customActions';
import { getNativeEditActions } from './nativeActions';
import { getSystemActions } from './systemActions';
import { PlatformContext } from './types';

export function initEditActionsServices(
  documentServicesAPI: DocumentServicesObject,
  manifestServicesAPI: ReturnType<typeof initBuilderServices>['manifest'],
  hostAPI: PlatformApiMethods,
  isBuilderServicesEnabled: boolean,
  editorPointerAPI?: EditorPointerAPI,
) {
  if (!isBuilderServicesEnabled || !editorPointerAPI) {
    return {
      generateEditActions: () => ({
        nativeActions: [],
        customActions: [],
        systemActions: [],
      }),
    };
  }

  function generateEditActions(
    editorPointer: EditorPointer<CompRef>,
    tags?: string[],
  ) {
    const platformContext: PlatformContext = {
      editorPointer,
      editorPointerAPI: editorPointerAPI!,
      documentServicesAPI,
      manifestServicesAPI,
      hostAPI,
    };

    return {
      nativeActions: getNativeEditActions(platformContext, tags),
      customActions: getCustomEditActions(platformContext, tags),
      systemActions: getSystemActions(platformContext, tags),
    };
  }

  return {
    generateEditActions,
  };
}
